import React from "react";

import Button from "@/components/UI/Button";
import images from "@/utils/images";

const ScreeningCard = (props) => {
  const { cancelHandler, cancelText, message, submitHandler, submitText, title } = props;
  const renderMessages = message.map((message, index) => {
    const className = index === 0 ? "fs-14" : "mt-2 fs-14";

    return (
      <div className={className} key={index}>
        {message}
      </div>
    );
  });

  const submitFn = submitHandler ? submitHandler : () => {};
  const cancelFn = cancelHandler ? cancelHandler : () => {};

  const submitClasses = cancelHandler
    ? "Btn Btn--pri Btn--sm-2 workflow-btn"
    : "Btn Btn--pri Btn--sm-2 workflow-btn Workflow__btn-Screening-home";

  return (
    <>
      <div className="p-lg-5 p-3">
        <div className="fs-22 txt-pri mb-5 text-center tw:font-bold">{title}</div>
        <div className="text-center my-5">
          <img
            alt="Eligibility Check"
            src={images("./common/workflow/eligibility-check-active.png")}
          />
        </div>
        <div className="workflow-container-sm font-color-gray">{renderMessages}</div>
      </div>
      <div className="workflow-container-sm d-flex justify-content-between">
        {cancelText && (
          <Button
            className="Btn Btn--otl-gry Btn--sm-2 workflow-btn"
            onClick={cancelFn}
            type="button"
          >
            {cancelText}
          </Button>
        )}
        <Button className={submitClasses} onClick={submitFn} type="button">
          {submitText}
        </Button>
      </div>
    </>
  );
};

export default ScreeningCard;
